import { createSvgIcon } from '@mui/material/utils';

export const BundleSizeIcon = createSvgIcon(
  <g fill="currentColor" fillRule="nonzero">
    <path
      d="M5.84 3c-.52 0-1 .25-1.3.67l-1.4 2.05c-.06.09-.1.19-.14.28h8V3H5.84zM20.86 5.72l-1.4-2.05c-.3-.42-.81-.67-1.33-.67H13v3h8c-.05-.1-.08-.2-.14-.28z"
      fillOpacity=".79"
    />
    <path
      d="M20.98 7H3.02L3 7.11V19.4c0 .89.71 1.61 1.58 1.61h14.84A1.6 1.6 0 0021 19.4V7.1L20.98 7zm-6.87 5.36H9.89a1.6 1.6 0 01-1.58-1.61c0-.89.7-1.6 1.58-1.6h4.22c.87 0 1.58.71 1.58 1.6 0 .89-.7 1.6-1.58 1.6z"
      fillOpacity=".87"
    />
  </g>,
  'BundleSize',
);
